import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0.35, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, children, testId }) => (
  <div className="flex items-center gap-4" data-testid={testId}>
    <span className="font-mono text-[11px] text-gold">{index}</span>
    <span className="h-px w-10 bg-white/15" />
    <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-400">{children}</span>
  </div>
);
